<template>
    <div>
        <div class="row">
            <div class="col-sm-12 col-md-12">
                <Card>
                    <div class="row mb-4">
                        <h5 class="col-sm-12 col-md-10 text-bold">{{ __('Release') }}</h5>

                        <div class="col-sm-12 col-md-12">&nbsp;</div>

                        <div class="col-sm-12 col-md-5">
                            <div class="row">
                                <div class="col-12">
                                    <dt>{{ __('Date of receipt') }}:</dt>
                                    <dd>{{ dateFormat(release.date) }}</dd>
                                </div>
                            </div>
                        </div>

                        <div class="hidden-sm col-md-2"></div>

                        <div class="col-sm-12 col-md-5">
                            <div class="row">
                                <div class="col-12">
                                    <dt>{{ __('Status') }}:</dt>
                                    <dd>{{ release.state.label }}</dd>
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-12 col-md-12">&nbsp;</div>

                        <div class="col-sm-12 col-md-5">
                            <div class="row">
                                <div class="col-12">
                                    <dt>{{ __('Invoice No') }}:</dt>
                                    <dd>{{ release.invoice }}</dd>
                                </div>
                            </div>
                        </div>

                        <div class="hidden-sm col-md-2"></div>

                        <div class="col-sm-12 col-md-5">
                            <div class="row">
                                <div class="col-12">
                                    <dt>{{ __('Payment start date') }}:</dt>
                                    <dd>{{ dateFormat(release.paymentStartDate) }}</dd>
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-12 col-md-12">&nbsp;</div>

                        <div class="col-sm-12 col-md-5">
                            <div class="row">
                                <div class="col-12">
                                    <dt>{{ __('Sender') }}:</dt>
                                    <dd>{{ release.senderCustomer.label }}</dd>
                                </div>
                            </div>
                        </div>

                        <div class="hidden-sm col-md-2"></div>

                        <div class="col-sm-12 col-md-5">
                            <div class="row">
                                <div class="col-12">
                                    <dt>{{ __('New payer') }}:</dt>
                                    <dd>{{ release.newPayerCustomer.label }}</dd>
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-12 col-md-12">&nbsp;</div>

                        <!-- <div class="col-sm-12 col-md-5">
                            <div class="row">
                                <div class="col-12">
                                    <dt>{{ __('Recipient') }}:</dt>
                                    <dd>{{ release.receiverCustomer.label }}</dd>
                                </div>
                            </div>
                        </div> -->

                        <div class="hidden-sm col-md-2"></div>

                        <div class="col-sm-12 col-md-5">
                            <div class="row">
                                <div class="col-12">
                                    <dt>{{ __('Recipient') }}:</dt>
                                    <dd>{{ release.newReceiverCustomer }}</dd>
                                </div>
                            </div>
                        </div>
                    </div>

                    <ShipmentsOverview :shipments="release.shipments"/>

                </Card>
                <br/>
                <div class="row">
                    <div class="col-12 text-right">
                        <button
                            @click="$router.push('/releases')"
                            class="btn btn-sm btn-info col-sm-6 col-md-4"
                        >
                            {{ __('Back') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapMutations } from 'vuex'
import { $api } from '../../services/api'
import ShipmentsOverview from './ShipmentsOverview'

export default {
  name: 'ReleaseView',

  components: { ShipmentsOverview },

  beforeRouteEnter (to, from, next) {
    $api.releases.item(to.params.id).then((release) => {
      next((vm) => {
        vm.setRelease(release.data)
      })
    })
  },

  computed: {
    ...mapGetters('ReleasesModule', [
      'release'
    ])
  },

  methods: {
    ...mapMutations('ReleasesModule', [
      'setRelease',
      'addReleaseShipment'
    ]),

    dateFormat (item) {
      return moment(item).format('YYYY-MM-DD')
    },
  }
}
</script>
